define('core/models/Forum',[
    'backbone',

    'core/UniqueModel',
    'core/api',
], function (
    Backbone,

    UniqueModel,
    api
) {
    'use strict';

    var Forum = Backbone.Model.extend({
        defaults: {
            settings: {},
            followUrl: 'forums/follow',
            unfollowUrl: 'forums/unfollow',
            isFollowing: false,
        },

        initialize: function (_attributes, options) {
            if (options && options.channel)
                this.channel = options.channel;

            this.getFeatures();
            this.on('change:id', this.getFeatures);
        },

        _changeFollowingState: function (path) {
            return api.call(path, {
                method: 'POST',
                data: {
                    target: this.get('id'),
                },
            });
        },

        follow: function () {
            this.set('isFollowing', true);

            return this._changeFollowingState(this.get('followUrl'));
        },

        unfollow: function () {
            this.set('isFollowing', false);

            return this._changeFollowingState(this.get('unfollowUrl'));
        },

        toggleFollowed: function () {
            if (this.channel && this.channel.get('options').isCurationOnlyChannel)
                return this.channel.toggleFollowed();

            var retval = this.get('isFollowing') ?
                this.unfollow() :
                this.follow();

            this.trigger('toggled:isFollowing');

            return retval;
        },

        getFeatures: function () {
            var self = this;

            // This api call lets us see what features are enabled for a forum. There are
            // a couple of features that require us to check if the feature is enabled
            // at an org level in addition to (or instead of) at the forum level.
            //
            // It checks to make sure that we have a forum id, which all forums should have.
            // But we don't have a forum id when initializing the forum in the embed.
            //
            // We also check to make sure that we don't already have the forum's features.
            // If we have it, then this api call is unnecessary because it will most likely
            // fetch data that we already have. It's possible that the features changed and
            // the api call would get new data, but that's an extreme edge case that is ignored.
            //
            // We also don't need to worry about the forum changing because
            // when that happens the embed has to have reloaded as well.
            if (self.id && !self.get('features')) {
                api.call('forums/details', {
                    data: {
                        forum: this.id,
                        attach: 'forumFeatures',
                    },
                    success: function (response) {
                        if (response && response.response)
                            self.set('features', response.response.features);
                    },
                });
            }
        },
    });

    UniqueModel.addType('Forum', Forum);

    return Forum;
});

